import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-print-document',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  template: `
<div class="print-document-button">
  <button mat-icon-button (click)="onClick()">
    <mat-icon>print</mat-icon>
  </button>
  </div>
  `
})
export class PrintDocumentComponent {
  id: any;

  url = '';

  type = '';

  @Input() set data(data: any) {
    if (data) {
      this.setData(data);
    }
  }

  setData(d: any) {

    if (d?.orderId) {
      this.id = d.orderId;
    }

    this.url = '/montage/documents/' + this.id;

    if (d?.id) {
      this.type = d.id;
      this.url += '/' + d.id;
    }

    if (d?.url) {
      this.url = d.url;
    }
    if (d?.printType) {
      this.type = d.printType;
    }
  }

  isPDF() {
    return this.type === 'pdf' ||
      ['agb', 'receipt', 'report'].indexOf(this.type) >= 0;
  }

  onClick() {
    const w = window as any;
    //MyLog.log('PRINT:', this.url, w.printJS);
    if (w.printJS) {
      const printType = this.isPDF() ? 'pdf' : 'image';

      w.printJS(
        {
          printable: this.url,
          type: printType,
          showModal: true,
          modalMessage: 'Dokument wird geladen ...',
          onError: (error: any) => {
            console.error('Dok nicht geladen', error);
          }
        });
    }
  }
}
